module.exports = __webpack_public_path__ + "static/desktop/img/typeset-mobile-calendar.da7595bf.png";